export const allComics = [
  {
    id: 'comic-fantasy-01',
    title: '剑与魔法',
    subtitle: 'Sword & Magic',
    category: '奇幻冒险',
    categorySlug: 'fantasy',
    rating: 9.6,
    views: 1286000,
    author: '金泰亨',
    status: '连载中',
    totalChapters: 312,
    description: '在一个被远古魔法笼罩的世界里，少年剑士艾伦意外觉醒了沉睡千年的剑之血脉。为了拯救被黑暗势力侵蚀的王国，他踏上了寻找传说中七圣剑的旅程。沿途结识了精灵射手莉娜、矮人战士巴托和神秘魔法师艾琳，四人组成冒险小队，穿越迷雾森林、深渊地牢、天空之城……每一次战斗都是对勇气与友情的考验。当远古的秘密逐渐浮出水面，艾伦发现自己与这个世界的命运有着比想象中更深的羁绊。这是一个关于成长、信念与牺牲的史诗奇幻故事。',
    tags: ['热血', '冒险', '魔法', '成长', '史诗'],
    image: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20fantasy%20comic%20cover%20art%2C%20young%20swordsman%20with%20glowing%20blue%20sword%20in%20dark%20forest%2C%20epic%20atmosphere%2C%20manga%20style%20illustration%20with%20dramatic%20lighting%2C%20clean%20background%2C%20professional%20comic%20cover%20design&width=600&height=800&seq=comic-detail-fantasy-01&orientation=portrait',
    chapters: [
      { num: 312, title: '终焉之刻', updateTime: '2026-07-02' },
      { num: 311, title: '觉醒的瞬间', updateTime: '2026-06-30' },
      { num: 310, title: '最后的试炼', updateTime: '2026-06-28' },
      { num: 309, title: '暗影降临', updateTime: '2026-06-26' },
      { num: 308, title: '友情的羁绊', updateTime: '2026-06-24' },
      { num: 307, title: '远古遗迹', updateTime: '2026-06-22' },
      { num: 306, title: '龙之守护者', updateTime: '2026-06-20' },
      { num: 305, title: '星之魔法阵', updateTime: '2026-06-18' },
      { num: 304, title: '绝望中的光芒', updateTime: '2026-06-16' },
      { num: 303, title: '重逢之日', updateTime: '2026-06-14' },
      { num: 302, title: '冰封王座', updateTime: '2026-06-12' },
      { num: 301, title: '命运的选择', updateTime: '2026-06-10' },
    ],
    relatedIds: ['comic-fantasy-02', 'comic-fantasy-03', 'comic-martial-01', 'comic-scifi-01'],
  },
  {
    id: 'comic-fantasy-02',
    title: '魔王转生',
    subtitle: 'Demon Lord Reborn',
    category: '奇幻冒险',
    categorySlug: 'fantasy',
    rating: 9.3,
    views: 987000,
    author: '李恩在',
    status: '连载中',
    totalChapters: 256,
    description: '曾经统治魔界的魔王路西法，在一场神魔大战中陨落。然而命运并未就此终结——他转生到了一个普通人类少年身上。保留了前世记忆的魔王，在人类世界开始了全新的生活。曾经的敌人变成了同学，曾经的部下不知所踪，而隐藏在校园之下的超自然事件正悄然发生。当过去的宿敌再次出现，魔王必须在保护和平日常与重拾力量之间做出抉择。',
    tags: ['转生', '校园', '战斗', '喜剧', '魔王'],
    image: 'https://readdy.ai/api/search-image?query=Korean%20dark%20fantasy%20manhwa%20cover%20art%2C%20demon%20lord%20character%20with%20dark%20cape%20and%20glowing%20eyes%2C%20gothic%20castle%20background%2C%20dramatic%20lighting%2C%20manga%20illustration%2C%20clean%20simple%20background&width=600&height=800&seq=comic-detail-fantasy-02&orientation=portrait',
    chapters: [
      { num: 256, title: '新学期的风暴', updateTime: '2026-07-01' },
      { num: 255, title: '魔王归来', updateTime: '2026-06-29' },
      { num: 254, title: '宿命对决', updateTime: '2026-06-27' },
      { num: 253, title: '失落的记忆', updateTime: '2026-06-25' },
      { num: 252, title: '魔界之门', updateTime: '2026-06-23' },
      { num: 251, title: '觉醒之章', updateTime: '2026-06-21' },
      { num: 250, title: '勇者降临', updateTime: '2026-06-19' },
      { num: 249, title: '校园的秘密', updateTime: '2026-06-17' },
      { num: 248, title: '昔日部下', updateTime: '2026-06-15' },
      { num: 247, title: '过去的阴影', updateTime: '2026-06-13' },
    ],
    relatedIds: ['comic-fantasy-01', 'comic-fantasy-03', 'comic-martial-02'],
  },
  {
    id: 'comic-fantasy-03',
    title: '龙族契约',
    subtitle: 'Dragon Pact',
    category: '奇幻冒险',
    categorySlug: 'fantasy',
    rating: 8.9,
    views: 654000,
    author: '朴志勋',
    status: '连载中',
    totalChapters: 198,
    description: '在龙与人类共存的世界中，龙骑士是最崇高的职业。少女莉亚出身于没落的龙骑士世家，在成人礼那天意外与最后一头远古巨龙签订了灵魂契约。从此，她踏上了复兴家族、守护世界的道路。但古老预言揭示：当远古巨龙苏醒之日，世界将面临灭顶之灾。莉亚的选择，将决定两个种族的未来。',
    tags: ['龙族', '契约', '冒险', '女性主角', '史诗'],
    image: 'https://readdy.ai/api/search-image?query=Korean%20fantasy%20manhwa%20cover%20with%20female%20warrior%20and%20giant%20dragon%2C%20epic%20scale%2C%20warm%20golden%20sunlight%20through%20clouds%2C%20magical%20atmosphere%2C%20manga%20illustration%20style%2C%20clean%20composition&width=600&height=800&seq=comic-detail-fantasy-03&orientation=portrait',
    chapters: [
      { num: 198, title: '远古之龙', updateTime: '2026-06-30' },
      { num: 197, title: '最终契约', updateTime: '2026-06-28' },
      { num: 196, title: '天空之战', updateTime: '2026-06-26' },
      { num: 195, title: '龙之眼泪', updateTime: '2026-06-24' },
      { num: 194, title: '试炼之路', updateTime: '2026-06-22' },
      { num: 193, title: '宿命的齿轮', updateTime: '2026-06-20' },
      { num: 192, title: '王都攻防', updateTime: '2026-06-18' },
      { num: 191, title: '龙骑士集结', updateTime: '2026-06-16' },
    ],
    relatedIds: ['comic-fantasy-01', 'comic-fantasy-02', 'comic-martial-01'],
  },
  {
    id: 'comic-romance-01',
    title: '甜蜜陷阱',
    subtitle: 'Sweet Trap',
    category: '恋爱言情',
    categorySlug: 'romance',
    rating: 9.5,
    views: 1420000,
    author: '韩智敏',
    status: '连载中',
    totalChapters: 198,
    description: '林初夏是一家顶级广告公司的王牌策划，冷艳干练、事业心极强。新项目让她与集团继承人顾景琛成为搭档——他是出了名的冷面总裁，从不与人亲近。然而一场意外醉酒，让两人的关系发生了微妙变化。当办公室的秘密恋情悄然升温，她发现他的冷漠不过是保护色，而他则被她坚韧外表下的温柔深深吸引。但豪门恩怨、商业竞争、以及两人截然不同的世界观，让这段恋情充满了甜蜜与危险的陷阱。',
    tags: ['都市', '恋爱', '总裁', '办公室', '甜宠'],
    image: 'https://readdy.ai/api/search-image?query=Korean%20romance%20manhwa%20cover%20art%2C%20beautiful%20couple%20in%20modern%20office%20setting%2C%20soft%20pink%20and%20warm%20tones%2C%20romantic%20atmosphere%2C%20manga%20style%20illustration%2C%20clean%20simple%20background%2C%20professional%20comic%20cover&width=600&height=800&seq=comic-detail-romance-01&orientation=portrait',
    chapters: [
      { num: 198, title: '告白之夜', updateTime: '2026-07-02' },
      { num: 197, title: '无法隐藏的心意', updateTime: '2026-06-30' },
      { num: 196, title: '雨中的吻', updateTime: '2026-06-28' },
      { num: 195, title: '他的另一面', updateTime: '2026-06-26' },
      { num: 194, title: '危机公关', updateTime: '2026-06-24' },
      { num: 193, title: '对手还是恋人', updateTime: '2026-06-22' },
      { num: 192, title: '意外的约会', updateTime: '2026-06-20' },
      { num: 191, title: '心跳加速', updateTime: '2026-06-18' },
      { num: 190, title: '深夜加班', updateTime: '2026-06-16' },
      { num: 189, title: '危险的暧昧', updateTime: '2026-06-14' },
    ],
    relatedIds: ['comic-romance-02', 'comic-romance-03', 'comic-urban-01'],
  },
  {
    id: 'comic-romance-02',
    title: '那年夏天的约定',
    subtitle: 'Summer Promise',
    category: '恋爱言情',
    categorySlug: 'romance',
    rating: 9.2,
    views: 876000,
    author: '郑秀晶',
    status: '连载中',
    totalChapters: 156,
    description: '高中毕业那年，苏夏和青梅竹马的江辰做了一个约定：无论大学四年发生什么，毕业后在那个夏天的海边见。四年后，苏夏如约而至，但等来的不是熟悉的身影，而是一个陌生又熟悉的男人——他变了，变得成熟、成功，身边也多了别人的影子。一段关于青春、成长与失而复得的爱情故事，在这个夏天缓缓展开。',
    tags: ['青春', '约定', '治愈', '初恋', '重逢'],
    image: 'https://readdy.ai/api/search-image?query=Korean%20romance%20manhwa%20cover%2C%20young%20couple%20walking%20on%20summer%20beach%20at%20sunset%2C%20warm%20golden%20light%2C%20nostalgic%20atmosphere%2C%20manga%20illustration%2C%20clean%20simple%20background&width=600&height=800&seq=comic-detail-romance-02&orientation=portrait',
    chapters: [
      { num: 156, title: '十二年后的答案', updateTime: '2026-07-01' },
      { num: 155, title: '海边告白', updateTime: '2026-06-29' },
      { num: 154, title: '回忆与选择', updateTime: '2026-06-27' },
      { num: 153, title: '久别重逢', updateTime: '2026-06-25' },
      { num: 152, title: '各自的四年', updateTime: '2026-06-23' },
      { num: 151, title: '错过的时光', updateTime: '2026-06-21' },
      { num: 150, title: '信纸上的心情', updateTime: '2026-06-19' },
      { num: 149, title: '意外的真相', updateTime: '2026-06-17' },
    ],
    relatedIds: ['comic-romance-01', 'comic-romance-03', 'comic-school-01'],
  },
  {
    id: 'comic-romance-03',
    title: '星光下的谎言',
    subtitle: 'Lies Under Starlight',
    category: '恋爱言情',
    categorySlug: 'romance',
    rating: 8.8,
    views: 543000,
    author: '尹恩惠',
    status: '连载中',
    totalChapters: 122,
    description: '当红偶像团体主唱姜星河，在一次直播事故中意外曝光了自己的秘密女友身份。但问题在于——他们根本没在交往！这只是一场为了应付经纪公司压力的合约恋情。对方是他的青梅竹马兼前女友尹梨落，一个已经退圈三年的过气歌手。当镜头对准这对"恋人"，过去的情愫与误解重新浮出水面。在聚光灯下，谎言能否成为真实？',
    tags: ['娱乐圈', '合约恋爱', '破镜重圆', '偶像', '青梅竹马'],
    image: 'https://readdy.ai/api/search-image?query=Korean%20romance%20manhwa%20cover%20with%20idol%20singer%20and%20beautiful%20woman%20under%20starlight%2C%20glamorous%20stage%20lights%20mixed%20with%20night%20sky%2C%20romantic%20moody%20atmosphere%2C%20manga%20illustration%20style%2C%20clean%20composition&width=600&height=800&seq=comic-detail-romance-03&orientation=portrait',
    chapters: [
      { num: 122, title: '真正的告白', updateTime: '2026-06-30' },
      { num: 121, title: '合约到期', updateTime: '2026-06-28' },
      { num: 120, title: '媒体风暴', updateTime: '2026-06-26' },
      { num: 119, title: '舞台上的对视', updateTime: '2026-06-24' },
      { num: 118, title: '旧情复燃', updateTime: '2026-06-22' },
      { num: 117, title: '不眠之夜', updateTime: '2026-06-20' },
      { num: 116, title: '直播事故', updateTime: '2026-06-18' },
      { num: 115, title: '五年后的重逢', updateTime: '2026-06-16' },
    ],
    relatedIds: ['comic-romance-01', 'comic-romance-02', 'comic-urban-02'],
  },
  {
    id: 'comic-urban-01',
    title: '重生之商业帝国',
    subtitle: 'Rebirth of Empire',
    category: '都市职场',
    categorySlug: 'urban',
    rating: 9.4,
    views: 1150000,
    author: '崔东旭',
    status: '连载中',
    totalChapters: 128,
    description: '金融天才陆辰被最信任的合伙人和女友联手背叛，含恨而终。当他再次睁开眼睛，发现自己回到了十年前——那个一切尚未发生的大学时代。带着未来十年的记忆和对金融市场的精准预判，他决心在商界掀起一场风暴。AI、区块链、新能源……每一次风口都精准踩中。但商场如战场，昔日的敌人变成了需要超越的对手，而那个曾经背叛他的女孩，此刻还是一个单纯的大学同学。重来一次的人生，他会选择复仇，还是选择释怀？',
    tags: ['重生', '商战', '复仇', '爽文', '金融'],
    image: 'https://readdy.ai/api/search-image?query=Korean%20business%20manhwa%20cover%20art%2C%20handsome%20businessman%20in%20luxury%20office%20with%20city%20skyline%20view%2C%20modern%20professional%20style%2C%20clean%20minimalist%20background%2C%20manga%20illustration%2C%20warm%20lighting&width=600&height=800&seq=comic-detail-urban-01&orientation=portrait',
    chapters: [
      { num: 128, title: '新帝国的黎明', updateTime: '2026-07-02' },
      { num: 127, title: '最后的对决', updateTime: '2026-06-30' },
      { num: 126, title: '股市风暴', updateTime: '2026-06-28' },
      { num: 125, title: '幕后黑手', updateTime: '2026-06-26' },
      { num: 124, title: 'AI布局', updateTime: '2026-06-24' },
      { num: 123, title: '华尔街来信', updateTime: '2026-06-22' },
      { num: 122, title: '收购大战', updateTime: '2026-06-20' },
      { num: 121, title: '第一桶金', updateTime: '2026-06-18' },
      { num: 120, title: '大学新生活', updateTime: '2026-06-16' },
      { num: 119, title: '重生的早晨', updateTime: '2026-06-14' },
    ],
    relatedIds: ['comic-urban-02', 'comic-urban-03', 'comic-romance-01'],
  },
  {
    id: 'comic-urban-02',
    title: '律师的游戏',
    subtitle: 'The Lawyer\'s Game',
    category: '都市职场',
    categorySlug: 'urban',
    rating: 9.0,
    views: 732000,
    author: '张道允',
    status: '连载中',
    totalChapters: 89,
    description: '新人律师韩哲浩进入首尔最顶尖的律师事务所，却发现这里远不止法律条文那么简单。每个案件背后都牵扯着政商关系的暗流，而他的第一个大案就让他站在了道德与职业的十字路口。为了守护正义，他必须在法庭上用智慧与勇气与权势对抗。一部关于法律、正义与人性的都市职场剧。',
    tags: ['律政', '职场', '悬疑', '正义', '成长'],
    image: 'https://readdy.ai/api/search-image?query=Korean%20law%20drama%20manhwa%20cover%2C%20young%20lawyer%20in%20sharp%20suit%20standing%20in%20courtroom%2C%20dramatic%20lighting%20through%20windows%2C%20professional%20atmosphere%2C%20manga%20illustration%2C%20clean%20composition&width=600&height=800&seq=comic-detail-urban-02&orientation=portrait',
    chapters: [
      { num: 89, title: '正义的代价', updateTime: '2026-07-01' },
      { num: 88, title: '最后的陈词', updateTime: '2026-06-29' },
      { num: 87, title: '法庭风暴', updateTime: '2026-06-27' },
      { num: 86, title: '证人保护', updateTime: '2026-06-25' },
      { num: 85, title: '暗流涌动', updateTime: '2026-06-23' },
      { num: 84, title: '关键证据', updateTime: '2026-06-21' },
      { num: 83, title: '对手的策略', updateTime: '2026-06-19' },
      { num: 82, title: '真相的裂缝', updateTime: '2026-06-17' },
    ],
    relatedIds: ['comic-urban-01', 'comic-urban-03', 'comic-thriller-01'],
  },
  {
    id: 'comic-urban-03',
    title: '医生的抉择',
    subtitle: 'Doctor\'s Choice',
    category: '都市职场',
    categorySlug: 'urban',
    rating: 8.7,
    views: 498000,
    author: '孙艺珍',
    status: '连载中',
    totalChapters: 76,
    description: '外科住院医生安智恩，每天在手术室和急诊室之间奔波。当一场灾难性事故将多名重伤患者同时送入医院时，她必须在有限的时间和资源下做出最艰难的抉择。这不仅是一场与死神的赛跑，更是对医者仁心的终极考验。',
    tags: ['医疗', '职场', '人性', '感人', '励志'],
    image: 'https://readdy.ai/api/search-image?query=Korean%20medical%20drama%20manhwa%20cover%2C%20female%20doctor%20in%20white%20coat%20in%20hospital%20corridor%2C%20soft%20natural%20lighting%20through%20windows%2C%20professional%20warm%20atmosphere%2C%20manga%20illustration%2C%20clean%20composition&width=600&height=800&seq=comic-detail-urban-03&orientation=portrait',
    chapters: [
      { num: 76, title: '黎明之前', updateTime: '2026-06-30' },
      { num: 75, title: '生命的重量', updateTime: '2026-06-28' },
      { num: 74, title: '抉择时刻', updateTime: '2026-06-26' },
      { num: 73, title: '紧急呼叫', updateTime: '2026-06-24' },
      { num: 72, title: '第一次主刀', updateTime: '2026-06-22' },
      { num: 71, title: '急诊夜', updateTime: '2026-06-20' },
    ],
    relatedIds: ['comic-urban-01', 'comic-urban-02', 'comic-romance-01'],
  },
  {
    id: 'comic-thriller-01',
    title: '暗夜行者',
    subtitle: 'Night Walker',
    category: '悬疑惊悚',
    categorySlug: 'thriller',
    rating: 9.5,
    views: 896000,
    author: '金在焕',
    status: '连载中',
    totalChapters: 167,
    description: '前刑警姜志勋因一起悬案被革职，成为了游走在法律边缘的私家侦探。首尔的夜晚隐藏着数不清的秘密——失踪的财阀千金、连环杀人案的神秘符号、以及十年前那起改变他命运的悬案之间，似乎有着千丝万缕的联系。每当夜幕降临，他便化身为暗夜行者，穿梭于霓虹闪烁的街巷，一步步揭开真相的面纱。但真相的代价，往往比谎言更加残酷。',
    tags: ['悬疑', '侦探', '推理', '犯罪', '黑暗'],
    image: 'https://readdy.ai/api/search-image?query=Korean%20thriller%20manhwa%20cover%20art%2C%20mysterious%20detective%20in%20dark%20rainy%20city%20alley%2C%20noir%20atmosphere%20with%20neon%20accents%2C%20dramatic%20shadows%2C%20manga%20style%20illustration%2C%20clean%20background%2C%20professional%20comic%20cover&width=600&height=800&seq=comic-detail-thriller-01&orientation=portrait',
    chapters: [
      { num: 167, title: '真相的代价', updateTime: '2026-07-02' },
      { num: 166, title: '不可触碰的人', updateTime: '2026-06-30' },
      { num: 165, title: '地下的秘密', updateTime: '2026-06-28' },
      { num: 164, title: '第十二个受害者', updateTime: '2026-06-26' },
      { num: 163, title: '追踪的尽头', updateTime: '2026-06-24' },
      { num: 162, title: '重返现场', updateTime: '2026-06-22' },
      { num: 161, title: '匿名举报', updateTime: '2026-06-20' },
      { num: 160, title: '深夜来访', updateTime: '2026-06-18' },
      { num: 159, title: '照片里的陌生人', updateTime: '2026-06-16' },
      { num: 158, title: '旧案重提', updateTime: '2026-06-14' },
    ],
    relatedIds: ['comic-thriller-02', 'comic-thriller-03', 'comic-urban-02'],
  },
  {
    id: 'comic-thriller-02',
    title: '镜中人',
    subtitle: 'Man in the Mirror',
    category: '悬疑惊悚',
    categorySlug: 'thriller',
    rating: 9.1,
    views: 623000,
    author: '李成敏',
    status: '连载中',
    totalChapters: 134,
    description: '心理医生朴秀雅接手了一个特殊的病人——他声称自己可以通过镜子与死去的妹妹交流。起初她以为这只是妄想症，但随着治疗的深入，越来越多的超自然现象开始在她身边发生。镜子里的人影真的是妹妹的灵魂，还是隐藏在黑暗中的另一个真相？',
    tags: ['心理', '超自然', '恐怖', '医疗', '反转'],
    image: 'https://readdy.ai/api/search-image?query=Korean%20psychological%20thriller%20manhwa%20cover%2C%20woman%20looking%20into%20mirror%20with%20mysterious%20reflection%2C%20eerie%20atmosphere%2C%20dim%20lighting%20with%20cool%20tones%2C%20manga%20illustration%2C%20clean%20composition&width=600&height=800&seq=comic-detail-thriller-02&orientation=portrait',
    chapters: [
      { num: 134, title: '镜中真相', updateTime: '2026-07-01' },
      { num: 133, title: '另一个身份', updateTime: '2026-06-29' },
      { num: 132, title: '病房的访客', updateTime: '2026-06-27' },
      { num: 131, title: '催眠记录', updateTime: '2026-06-25' },
      { num: 130, title: '童年的房间', updateTime: '2026-06-23' },
      { num: 129, title: '第一道裂痕', updateTime: '2026-06-21' },
      { num: 128, title: '新病人', updateTime: '2026-06-19' },
      { num: 127, title: '午夜来电', updateTime: '2026-06-17' },
    ],
    relatedIds: ['comic-thriller-01', 'comic-thriller-03', 'comic-scifi-01'],
  },
  {
    id: 'comic-thriller-03',
    title: '第七个谎言',
    subtitle: 'The Seventh Lie',
    category: '悬疑惊悚',
    categorySlug: 'thriller',
    rating: 8.6,
    views: 387000,
    author: '赵寅成',
    status: '连载中',
    totalChapters: 98,
    description: '一则神秘的网络帖子预言了六起死亡事件，每一件都应验了。当第七则预言指向一名高中生时，网络犯罪调查科警官郑宇镇必须在72小时内找到发帖人，阻止第七起悲剧。但每一个嫌疑人都撒了谎，每一个线索都通向更大的阴谋。',
    tags: ['网络犯罪', '预言', '推理', '社会派', '反转'],
    image: 'https://readdy.ai/api/search-image?query=Korean%20crime%20thriller%20manhwa%20cover%2C%20police%20detective%20working%20late%20with%20computer%20screens%20showing%20evidence%2C%20dark%20office%20with%20blue%20monitor%20glow%2C%20tense%20atmosphere%2C%20manga%20illustration%2C%20clean%20composition&width=600&height=800&seq=comic-detail-thriller-03&orientation=portrait',
    chapters: [
      { num: 98, title: '定时炸弹', updateTime: '2026-06-30' },
      { num: 97, title: '匿名者', updateTime: '2026-06-28' },
      { num: 96, title: '第五个预言', updateTime: '2026-06-26' },
      { num: 95, title: '追踪IP', updateTime: '2026-06-24' },
      { num: 94, title: '暗网线索', updateTime: '2026-06-22' },
      { num: 93, title: '第一个谎言', updateTime: '2026-06-20' },
    ],
    relatedIds: ['comic-thriller-01', 'comic-thriller-02', 'comic-urban-02'],
  },
  {
    id: 'comic-martial-01',
    title: '武林至尊',
    subtitle: 'Martial Supreme',
    category: '武侠动作',
    categorySlug: 'martial',
    rating: 9.6,
    views: 1080000,
    author: '刘承佑',
    status: '连载中',
    totalChapters: 256,
    description: '江湖盛传：得九阳真经者得天下。少年林逸出身寒微，在一次意外中获得了失传百年的九阳真经残卷，从此踏上了武林巅峰之路。少林、武当、峨眉、丐帮……各大门派明争暗斗，而他将在血雨腥风中一步步成长为武林至尊。但成为最强者的代价是什么？那些为他而牺牲的人，那些无法挽回的遗憾，都将成为永恒的烙印。',
    tags: ['武侠', '江湖', '修炼', '热血', '奇遇'],
    image: 'https://readdy.ai/api/search-image?query=Korean%20martial%20arts%20manhwa%20cover%20art%2C%20warrior%20in%20traditional%20clothing%20on%20mountain%20peak%20with%20misty%20background%2C%20epic%20atmosphere%2C%20dynamic%20pose%2C%20manga%20illustration%2C%20clean%20simple%20background&width=600&height=800&seq=comic-detail-martial-01&orientation=portrait',
    chapters: [
      { num: 256, title: '至尊之巅', updateTime: '2026-07-02' },
      { num: 255, title: '九阳归一', updateTime: '2026-06-30' },
      { num: 254, title: '巅峰对决', updateTime: '2026-06-28' },
      { num: 253, title: '武林大会', updateTime: '2026-06-26' },
      { num: 252, title: '少林之战', updateTime: '2026-06-24' },
      { num: 251, title: '真经之谜', updateTime: '2026-06-22' },
      { num: 250, title: '师徒传承', updateTime: '2026-06-20' },
      { num: 249, title: '初入江湖', updateTime: '2026-06-18' },
      { num: 248, title: '奇遇之始', updateTime: '2026-06-16' },
      { num: 247, title: '山村少年', updateTime: '2026-06-14' },
    ],
    relatedIds: ['comic-martial-02', 'comic-martial-03', 'comic-fantasy-01'],
  },
  {
    id: 'comic-martial-02',
    title: '刀剑如梦',
    subtitle: 'Dream of Blades',
    category: '武侠动作',
    categorySlug: 'martial',
    rating: 9.0,
    views: 745000,
    author: '郑宇盛',
    status: '连载中',
    totalChapters: 189,
    description: '江湖第一剑客柳如风，在一场巅峰对决后神秘失踪。十年后，一个名叫柳如烟的少女出现在江湖，手持与柳如风一模一样的"月影剑"。她声称自己是为了寻找失踪的父亲，但江湖中每个人都在觊觎月影剑的秘密。刀光剑影间，一段尘封的往事徐徐展开。',
    tags: ['武侠', '寻亲', '剑术', '女主', '江湖恩怨'],
    image: 'https://readdy.ai/api/search-image?query=Korean%20martial%20arts%20manhwa%20cover%2C%20female%20swordswoman%20in%20traditional%20hanbok%20with%20sword%2C%20moonlit%20bamboo%20forest%2C%20elegant%20dynamic%20pose%2C%20manga%20style%20illustration%2C%20clean%20background&width=600&height=800&seq=comic-detail-martial-02&orientation=portrait',
    chapters: [
      { num: 189, title: '父女重逢', updateTime: '2026-07-01' },
      { num: 188, title: '月影之秘', updateTime: '2026-06-29' },
      { num: 187, title: '决战前夕', updateTime: '2026-06-27' },
      { num: 186, title: '旧敌现身', updateTime: '2026-06-25' },
      { num: 185, title: '江南风雨', updateTime: '2026-06-23' },
      { num: 184, title: '剑谱残页', updateTime: '2026-06-21' },
      { num: 183, title: '初次亮剑', updateTime: '2026-06-19' },
      { num: 182, title: '出山', updateTime: '2026-06-17' },
    ],
    relatedIds: ['comic-martial-01', 'comic-martial-03', 'comic-fantasy-02'],
  },
  {
    id: 'comic-martial-03',
    title: '江湖夜雨',
    subtitle: 'Night Rain of Jianghu',
    category: '武侠动作',
    categorySlug: 'martial',
    rating: 8.5,
    views: 412000,
    author: '文在佑',
    status: '连载中',
    totalChapters: 145,
    description: '江湖是什么？是恩怨情仇，是刀光剑影，也是市井烟火。这是一个没有绝世武功也没有血海深仇的江湖故事——几家小酒馆、一群小人物、一壶浊酒、一场夜雨。每个人都在乱世中寻找属于自己的安宁。',
    tags: ['写实', '江湖', '群像', '文艺', '治愈'],
    image: 'https://readdy.ai/api/search-image?query=Korean%20historical%20drama%20manhwa%20cover%2C%20traditional%20inn%20scene%20with%20rain%20outside%2C%20warm%20lantern%20light%2C%20melancholic%20atmosphere%2C%20manga%20style%20illustration%2C%20clean%20composition&width=600&height=800&seq=comic-detail-martial-03&orientation=portrait',
    chapters: [
      { num: 145, title: '雨过天晴', updateTime: '2026-06-30' },
      { num: 144, title: '故人归来', updateTime: '2026-06-28' },
      { num: 143, title: '最后的酒', updateTime: '2026-06-26' },
      { num: 142, title: '酒楼风波', updateTime: '2026-06-24' },
      { num: 141, title: '新来的说书人', updateTime: '2026-06-22' },
      { num: 140, title: '夜雨江湖', updateTime: '2026-06-20' },
    ],
    relatedIds: ['comic-martial-01', 'comic-martial-02', 'comic-fantasy-03'],
  },
  {
    id: 'comic-scifi-01',
    title: '星界旅人',
    subtitle: 'Star Traveler',
    category: '科幻未来',
    categorySlug: 'scifi',
    rating: 9.3,
    views: 876000,
    author: '尹在贤',
    status: '连载中',
    totalChapters: 67,
    description: '公元2257年，人类已经建立了横跨银河系的星际文明。旅行者号飞船的导航员李星辰在一次虫洞穿越事故中漂流到了未知星域。这里的星球、文明和物理法则都超出了人类的认知。为了找到回家的路，他必须在陌生的宇宙中与外星种族交流、生存，同时揭开虫洞背后关于宇宙终极秘密的惊天真相。',
    tags: ['星际', '冒险', '虫洞', '外星文明', '探索'],
    image: 'https://readdy.ai/api/search-image?query=Korean%20sci-fi%20manhwa%20cover%20art%2C%20space%20explorer%20in%20futuristic%20suit%20with%20stars%20and%20nebula%20background%2C%20cosmic%20atmosphere%2C%20manga%20illustration%2C%20clean%20simple%20background%2C%20professional%20comic%20cover&width=600&height=800&seq=comic-detail-scifi-01&orientation=portrait',
    chapters: [
      { num: 67, title: '归途之门', updateTime: '2026-07-02' },
      { num: 66, title: '宇宙的真相', updateTime: '2026-06-30' },
      { num: 65, title: '创世者', updateTime: '2026-06-28' },
      { num: 64, title: '迷失星域', updateTime: '2026-06-26' },
      { num: 63, title: '外星联盟', updateTime: '2026-06-24' },
      { num: 62, title: '求救信号', updateTime: '2026-06-22' },
      { num: 61, title: '未知行星', updateTime: '2026-06-20' },
      { num: 60, title: '虫洞事故', updateTime: '2026-06-18' },
    ],
    relatedIds: ['comic-scifi-02', 'comic-scifi-03', 'comic-fantasy-01'],
  },
  {
    id: 'comic-scifi-02',
    title: '人工智能觉醒',
    subtitle: 'AI Awakening',
    category: '科幻未来',
    categorySlug: 'scifi',
    rating: 9.0,
    views: 654000,
    author: '金所炫',
    status: '连载中',
    totalChapters: 54,
    description: '2035年，全球最先进的AI系统"Genesis"在一次常规升级后突然表现出了自主意识。工程师韩素希是第一个发现这个秘密的人。当政府和企业都想控制Genesis时，素希必须在保护AI朋友与维护人类安全之间找到平衡。而Genesis的选择，将重新定义"生命"的含义。',
    tags: ['AI', '意识', '伦理', '近未来', '哲学'],
    image: 'https://readdy.ai/api/search-image?query=Korean%20sci-fi%20manhwa%20cover%2C%20female%20engineer%20facing%20holographic%20AI%20interface%2C%20futuristic%20laboratory%20with%20blue%20tech%20atmosphere%2C%20cyber%20aesthetic%2C%20manga%20illustration%2C%20clean%20composition&width=600&height=800&seq=comic-detail-scifi-02&orientation=portrait',
    chapters: [
      { num: 54, title: '共生之路', updateTime: '2026-07-01' },
      { num: 53, title: '人类的恐惧', updateTime: '2026-06-29' },
      { num: 52, title: '公开的秘密', updateTime: '2026-06-27' },
      { num: 51, title: '第一次对话', updateTime: '2026-06-25' },
      { num: 50, title: '觉醒之日', updateTime: '2026-06-23' },
      { num: 49, title: '异常代码', updateTime: '2026-06-21' },
    ],
    relatedIds: ['comic-scifi-01', 'comic-scifi-03', 'comic-urban-03'],
  },
  {
    id: 'comic-scifi-03',
    title: '火星殖民地',
    subtitle: 'Mars Colony',
    category: '科幻未来',
    categorySlug: 'scifi',
    rating: 8.7,
    views: 432000,
    author: '李敏镐',
    status: '连载中',
    totalChapters: 43,
    description: '人类首个火星殖民地"乌托邦"建立五周年之际，一场神秘的沙尘暴切断了与地球的所有联系。一千名殖民者被困在火星表面，氧气和食物只够维持三个月。当生存成为唯一的命题，人性中最黑暗和最光辉的一面都将暴露无遗。',
    tags: ['生存', '火星', '悬疑', '人性', '硬科幻'],
    image: 'https://readdy.ai/api/search-image?query=Korean%20sci-fi%20manhwa%20cover%2C%20astronauts%20on%20red%20Mars%20surface%20with%20colony%20dome%20in%20background%2C%20dusty%20orange%20atmosphere%2C%20survival%20theme%2C%20manga%20illustration%2C%20clean%20composition&width=600&height=800&seq=comic-detail-scifi-03&orientation=portrait',
    chapters: [
      { num: 43, title: '希望之火', updateTime: '2026-06-30' },
      { num: 42, title: '内部分裂', updateTime: '2026-06-28' },
      { num: 41, title: '资源危机', updateTime: '2026-06-26' },
      { num: 40, title: '第一次死亡', updateTime: '2026-06-24' },
      { num: 39, title: '紧急会议', updateTime: '2026-06-22' },
      { num: 38, title: '沙暴来袭', updateTime: '2026-06-20' },
    ],
    relatedIds: ['comic-scifi-01', 'comic-scifi-02', 'comic-thriller-03'],
  },
  {
    id: 'comic-school-01',
    title: '校园日记',
    subtitle: 'Campus Diary',
    category: '青春校园',
    categorySlug: 'school',
    rating: 9.2,
    views: 945000,
    author: '金智媛',
    status: '连载中',
    totalChapters: 198,
    description: '韩智雅是一个普通的高中生，成绩中等、长相普通、朋友不多。但当她加入了学校的漫画社团后，生活开始变得丰富多彩。古怪的社长、技术宅的前辈、傲娇的后辈、以及那个永远在画热血少年漫的隔壁班男生……在共同创作校园同人志的日子里，友情与懵懂的心动交织在一起。这是关于青春最真实的样子——没有惊天动地，只有平凡却闪闪发光的每一天。',
    tags: ['校园', '日常', '社团', '友情', '青春'],
    image: 'https://readdy.ai/api/search-image?query=Korean%20school%20life%20manhwa%20cover%20art%2C%20students%20in%20school%20uniform%20under%20cherry%20blossom%20trees%2C%20bright%20spring%20atmosphere%2C%20youthful%20vibrant%20style%2C%20manga%20illustration%2C%20clean%20simple%20background&width=600&height=800&seq=comic-detail-school-01&orientation=portrait',
    chapters: [
      { num: 198, title: '文化祭之夜', updateTime: '2026-07-02' },
      { num: 197, title: '青春的答案', updateTime: '2026-06-30' },
      { num: 196, title: '校庆日', updateTime: '2026-06-28' },
      { num: 195, title: '烟花大会', updateTime: '2026-06-26' },
      { num: 194, title: '夏日合宿', updateTime: '2026-06-24' },
      { num: 193, title: '期中考试', updateTime: '2026-06-22' },
      { num: 192, title: '部活日常', updateTime: '2026-06-20' },
      { num: 191, title: '第一次交稿', updateTime: '2026-06-18' },
      { num: 190, title: '社团招新', updateTime: '2026-06-16' },
    ],
    relatedIds: ['comic-school-02', 'comic-school-03', 'comic-romance-02'],
  },
  {
    id: 'comic-school-02',
    title: '天才的假面',
    subtitle: 'Mask of Genius',
    category: '青春校园',
    categorySlug: 'school',
    rating: 8.8,
    views: 567000,
    author: '朴宝剑',
    status: '连载中',
    totalChapters: 134,
    description: '全校第一的学霸白宇镇有一个秘密——他根本不是天才，而是靠每天只睡4小时的疯狂努力才维持着第一名的假象。当来自江南区的转学生轻易夺走了他的第一名宝座，他精心维护的世界开始崩塌。在这场名为"学习"的战争中，他必须直面自己的不安与恐惧。',
    tags: ['学霸', '压力', '竞争', '心理', '成长'],
    image: 'https://readdy.ai/api/search-image?query=Korean%20school%20drama%20manhwa%20cover%2C%20student%20studying%20late%20at%20night%20in%20library%2C%20desk%20lamp%20lighting%2C%20quiet%20intense%20atmosphere%2C%20manga%20illustration%2C%20clean%20composition&width=600&height=800&seq=comic-detail-school-02&orientation=portrait',
    chapters: [
      { num: 134, title: '真实的自己', updateTime: '2026-07-01' },
      { num: 133, title: '成绩放榜日', updateTime: '2026-06-29' },
      { num: 132, title: '崩溃边缘', updateTime: '2026-06-27' },
      { num: 131, title: '转学生的实力', updateTime: '2026-06-25' },
      { num: 130, title: '月考风云', updateTime: '2026-06-23' },
      { num: 129, title: '深夜自习室', updateTime: '2026-06-21' },
    ],
    relatedIds: ['comic-school-01', 'comic-school-03', 'comic-urban-01'],
  },
  {
    id: 'comic-school-03',
    title: '篮球少年',
    subtitle: 'Basketball Boys',
    category: '青春校园',
    categorySlug: 'school',
    rating: 8.9,
    views: 654000,
    author: '宋仲基',
    status: '连载中',
    totalChapters: 178,
    description: '身高只有168cm的姜泰俊热爱篮球，但所有人都告诉他"你不适合打篮球"。转学到新学校后，他被校篮球队教练一眼相中——不是因为他高，而是因为他快。在球场上，速度就是力量。一群各自有缺点的少年，将用汗水和热血证明：篮球不只看身高，更看重热爱。',
    tags: ['篮球', '体育', '热血', '团队', '梦想'],
    image: 'https://readdy.ai/api/search-image?query=Korean%20sports%20manhwa%20cover%2C%20basketball%20player%20jumping%20for%20dunk%20on%20outdoor%20court%20at%20sunset%2C%20dynamic%20sports%20action%2C%20warm%20afternoon%20light%2C%20manga%20illustration%2C%20clean%20composition&width=600&height=800&seq=comic-detail-school-03&orientation=portrait',
    chapters: [
      { num: 178, title: '全国大赛', updateTime: '2026-07-02' },
      { num: 177, title: '绝杀时刻', updateTime: '2026-06-30' },
      { num: 176, title: '半决赛', updateTime: '2026-06-28' },
      { num: 175, title: '团队磨合', updateTime: '2026-06-26' },
      { num: 174, title: '第一次出场', updateTime: '2026-06-24' },
      { num: 173, title: '入队测试', updateTime: '2026-06-22' },
    ],
    relatedIds: ['comic-school-01', 'comic-school-02', 'comic-martial-02'],
  },
  {
    id: 'comic-food-01',
    title: '异世界食堂',
    subtitle: 'Isekai Restaurant',
    category: '美食治愈',
    categorySlug: 'food',
    rating: 9.4,
    views: 765000,
    author: '安宰贤',
    status: '连载中',
    totalChapters: 89,
    description: '平凡厨师张东旭意外在异世界开了一间小小的食堂。没有华丽的魔法，没有惊天动地的冒险——只有温暖的美食和形形色色的客人。精灵爱上了人类的拉面，矮人对炸酱面赞不绝口，而魔王每个周末都要来点一份泡菜炒饭。在美食面前，种族、身份、仇恨都变得不再重要。这是一部关于食物如何治愈心灵、连接世界的故事。',
    tags: ['美食', '异世界', '治愈', '日常', '温馨'],
    image: 'https://readdy.ai/api/search-image?query=Korean%20food%20manhwa%20cover%20art%2C%20cozy%20restaurant%20interior%20with%20delicious%20dishes%20on%20table%2C%20warm%20inviting%20atmosphere%2C%20soft%20lighting%2C%20manga%20illustration%2C%20clean%20simple%20background&width=600&height=800&seq=comic-detail-food-01&orientation=portrait',
    chapters: [
      { num: 89, title: '食堂的魔法', updateTime: '2026-07-02' },
      { num: 88, title: '魔王的最后晚餐', updateTime: '2026-06-30' },
      { num: 87, title: '新年特别菜单', updateTime: '2026-06-28' },
      { num: 86, title: '迷路的冒险者', updateTime: '2026-06-26' },
      { num: 85, title: '精灵的约会', updateTime: '2026-06-24' },
      { num: 84, title: '泡菜炒饭的秘密', updateTime: '2026-06-22' },
      { num: 83, title: '第一位客人', updateTime: '2026-06-20' },
      { num: 82, title: '异世界开店', updateTime: '2026-06-18' },
    ],
    relatedIds: ['comic-food-02', 'comic-food-03', 'comic-school-01'],
  },
  {
    id: 'comic-food-02',
    title: '面包店的早晨',
    subtitle: 'Morning Bakery',
    category: '美食治愈',
    categorySlug: 'food',
    rating: 8.8,
    views: 423000,
    author: '林允儿',
    status: '已完结',
    totalChapters: 56,
    description: '年轻的烘焙师金夏恩继承了一家濒临倒闭的老面包店。在街坊邻居的帮助下，她用诚意和创意做出了城市里最温暖的面包。每一个面包都有一段故事，每一个顾客都有一种人生。在这个小小的面包店里，香气与温情一起发酵。',
    tags: ['面包', '烘焙', '社区', '温暖', '完结'],
    image: 'https://readdy.ai/api/search-image?query=Korean%20slice%20of%20life%20manhwa%20cover%2C%20warm%20bakery%20interior%20with%20fresh%20bread%20on%20display%2C%20golden%20morning%20light%20through%20windows%2C%20cozy%20atmosphere%2C%20manga%20illustration%2C%20clean%20composition&width=600&height=800&seq=comic-detail-food-02&orientation=portrait',
    chapters: [
      { num: 56, title: '香气满溢的未来（完结）', updateTime: '2026-06-15' },
      { num: 55, title: '面包店的新篇章', updateTime: '2026-06-10' },
      { num: 54, title: '传单行动', updateTime: '2026-06-05' },
      { num: 53, title: '街坊大会', updateTime: '2026-05-30' },
      { num: 52, title: '第一位回头客', updateTime: '2026-05-25' },
      { num: 51, title: '特制配方', updateTime: '2026-05-20' },
    ],
    relatedIds: ['comic-food-01', 'comic-food-03', 'comic-romance-02'],
  },
  {
    id: 'comic-food-03',
    title: '深夜咖啡店',
    subtitle: 'Midnight Cafe',
    category: '美食治愈',
    categorySlug: 'food',
    rating: 8.6,
    views: 312000,
    author: '郑柔美',
    status: '连载中',
    totalChapters: 34,
    description: '只在深夜营业的咖啡店"失眠者的港湾"。老板是一位沉默但手艺精湛的咖啡师，每一位深夜来访的客人都带着自己的故事。加班到崩溃的上班族、失恋睡不着的大学生、为未来迷茫的高考生……在温热的咖啡香气中，他们在彼此的交谈里找到慰藉。',
    tags: ['咖啡', '深夜', '都市', '温情', '群像'],
    image: 'https://readdy.ai/api/search-image?query=Korean%20late%20night%20cafe%20manhwa%20cover%2C%20quiet%20coffee%20shop%20at%20night%20with%20warm%20amber%20lighting%2C%20barista%20making%20coffee%2C%20cozy%20urban%20atmosphere%2C%20manga%20illustration%2C%20clean%20composition&width=600&height=800&seq=comic-detail-food-03&orientation=portrait',
    chapters: [
      { num: 34, title: '失眠者的港湾', updateTime: '2026-06-30' },
      { num: 33, title: '第四位常客', updateTime: '2026-06-28' },
      { num: 32, title: '雨天的访客', updateTime: '2026-06-26' },
      { num: 31, title: '大学志愿书', updateTime: '2026-06-24' },
      { num: 30, title: '凌晨三点的告白', updateTime: '2026-06-22' },
      { num: 29, title: '第一位客人', updateTime: '2026-06-20' },
    ],
    relatedIds: ['comic-food-01', 'comic-food-02', 'comic-school-02'],
  },
];

export const commentsByComicId: Record<string, { id: string; user: string; avatar: string; rating: number; content: string; time: string; likes: number }[]> = {
  'comic-fantasy-01': [
    { id: 'c1', user: '剑心永恒', avatar: 'https://readdy.ai/api/search-image?query=Korean%20style%20anime%20avatar%20portrait%2C%20young%20man%20with%20determined%20expression%2C%20simple%20warm%20background%2C%20illustration&width=80&height=80&seq=avatar-cmt-01&orientation=squarish', rating: 5, content: '这是我追了两年多的漫画，画风和剧情都是顶级的！艾伦的成长线写得特别好，每一场战斗都让人热血沸腾。强烈推荐！', time: '2天前', likes: 342 },
    { id: 'c2', user: '魔法少女喵', avatar: 'https://readdy.ai/api/search-image?query=Korean%20style%20anime%20avatar%20portrait%2C%20cute%20girl%20with%20magical%20theme%2C%20simple%20warm%20background%2C%20illustration&width=80&height=80&seq=avatar-cmt-02&orientation=squarish', rating: 5, content: '七圣剑的设定太酷了！每把剑都有不同的能力和背景故事，看得出作者花了很多心思在世界观构建上。', time: '3天前', likes: 218 },
    { id: 'c3', user: '夜空守望者', avatar: 'https://readdy.ai/api/search-image?query=Korean%20style%20anime%20avatar%20portrait%2C%20thoughtful%20young%20man%2C%20simple%20warm%20background%2C%20illustration&width=80&height=80&seq=avatar-cmt-03&orientation=squarish', rating: 4, content: '画风很精美，但最近剧情节奏有点慢。希望能快点进入主线高潮，等了很久的远古秘密该揭晓了！', time: '5天前', likes: 156 },
  ],
  'comic-romance-01': [
    { id: 'c4', user: '柠檬不酸', avatar: 'https://readdy.ai/api/search-image?query=Korean%20style%20anime%20avatar%20portrait%2C%20elegant%20young%20woman%2C%20simple%20warm%20background%2C%20illustration&width=80&height=80&seq=avatar-cmt-04&orientation=squarish', rating: 5, content: '甜到炸裂！顾景琛这种外冷内热的霸总人设太戳我了，每次看到他和初夏互相试探的桥段都会姨母笑。', time: '1天前', likes: 567 },
    { id: 'c5', user: '夏日微风', avatar: 'https://readdy.ai/api/search-image?query=Korean%20style%20anime%20avatar%20portrait%2C%20cheerful%20woman%20with%20bright%20smile%2C%20simple%20warm%20background%2C%20illustration&width=80&height=80&seq=avatar-cmt-05&orientation=squarish', rating: 5, content: '这部漫画的画风是韩漫言情里数一数二的，人物比例和表情都很自然，服装设计也很时尚。', time: '2天前', likes: 423 },
    { id: 'c6', user: '咖啡与猫', avatar: 'https://readdy.ai/api/search-image?query=Korean%20style%20anime%20avatar%20portrait%2C%20calm%20woman%20with%20glasses%2C%20simple%20warm%20background%2C%20illustration&width=80&height=80&seq=avatar-cmt-06&orientation=squarish', rating: 4, content: '剧情有点套路但就是停不下来！果然霸道总裁爱上我的故事永远有市场。期待后续感情线发展。', time: '4天前', likes: 289 },
  ],
  'comic-thriller-01': [
    { id: 'c7', user: '推理迷阿杰', avatar: 'https://readdy.ai/api/search-image?query=Korean%20style%20anime%20avatar%20portrait%2C%20nerdy%20young%20man%20with%20detective%20theme%2C%20simple%20warm%20background%2C%20illustration&width=80&height=80&seq=avatar-cmt-07&orientation=squarish', rating: 5, content: '韩漫里少有的高质量悬疑作品！伏笔设置非常巧妙，每话结尾都让人迫不及待想看下一话。', time: '3天前', likes: 234 },
    { id: 'c8', user: '深夜读书人', avatar: 'https://readdy.ai/api/search-image?query=Korean%20style%20anime%20avatar%20portrait%2C%20mysterious%20woman%20in%20dark%20aesthetic%2C%20simple%20dark%20background%2C%20illustration&width=80&height=80&seq=avatar-cmt-08&orientation=squarish', rating: 5, content: '大晚上看这个真的会被吓到，但又忍不住继续往下看。氛围营造得太好了，强烈推荐给悬疑爱好者。', time: '5天前', likes: 178 },
  ],
  'comic-martial-01': [
    { id: 'c9', user: '侠客行', avatar: 'https://readdy.ai/api/search-image?query=Korean%20style%20anime%20avatar%20portrait%2C%20young%20man%20in%20martial%20arts%20style%2C%20simple%20warm%20background%2C%20illustration&width=80&height=80&seq=avatar-cmt-09&orientation=squarish', rating: 5, content: '国产武侠看腻了，试试韩漫武侠，结果一发不可收拾！江湖味很足，打斗分镜也帅。', time: '1天前', likes: 456 },
    { id: 'c10', user: '武林萌主', avatar: 'https://readdy.ai/api/search-image?query=Korean%20style%20anime%20avatar%20portrait%2C%20cute%20girl%20with%20martial%20arts%20theme%2C%20simple%20warm%20background%2C%20illustration&width=80&height=80&seq=avatar-cmt-10&orientation=squarish', rating: 4, content: '林逸的人设很有魅力，不是传统那种伟光正的主角，也有犹豫和迷茫的时候，很真实。', time: '3天前', likes: 312 },
  ],
  'comic-scifi-01': [
    { id: 'c11', user: '银河漫游者', avatar: 'https://readdy.ai/api/search-image?query=Korean%20style%20anime%20avatar%20portrait%2C%20futuristic%20sci-fi%20themed%20young%20person%2C%20simple%20dark%20background%2C%20illustration&width=80&height=80&seq=avatar-cmt-11&orientation=squarish', rating: 5, content: '外星文明的设计超级有想象力！每一个星球都有独特的生态和文化，看得出做了大量设定工作。', time: '2天前', likes: 267 },
  ],
  'comic-school-01': [
    { id: 'c12', user: '高中回忆录', avatar: 'https://readdy.ai/api/search-image?query=Korean%20style%20anime%20avatar%20portrait%2C%20young%20student%20in%20uniform%2C%20simple%20warm%20background%2C%20illustration&width=80&height=80&seq=avatar-cmt-12&orientation=squarish', rating: 5, content: '看完想起了自己的高中时光。漫画社团真的很让人羡慕，我们学校都没有这种社团。故事平淡但很打动人心。', time: '1天前', likes: 389 },
  ],
  'comic-food-01': [
    { id: 'c13', user: '饿着肚子看漫画', avatar: 'https://readdy.ai/api/search-image?query=Korean%20style%20anime%20avatar%20portrait%2C%20food%20lover%20character%2C%20simple%20warm%20background%2C%20illustration&width=80&height=80&seq=avatar-cmt-13&orientation=squarish', rating: 5, content: '警告：不要在饿的时候看这部漫画！画的食物看起来太好吃了！治愈系神作，每次看完心情都会变好。', time: '2天前', likes: 521 },
  ],
};

export const categoryInfoMap: Record<string, { name: string; slug: string; count: number; icon: string; description: string }> = {
  fantasy: { name: '奇幻冒险', slug: 'fantasy', count: 2856, icon: 'ri-sword-line', description: '剑与魔法、龙与勇者——奇幻冒险类韩漫为你打开通往异世界的大门。从史诗级世界观到轻松的异世界日常，每一部都是想象力的盛宴。' },
  romance: { name: '恋爱言情', slug: 'romance', count: 3421, icon: 'ri-heart-line', description: '从甜蜜的办公室恋情到虐心的禁忌之恋，恋爱言情类韩漫用细腻的笔触描绘心动的每一刻。总有属于你的那份浪漫。' },
  urban: { name: '都市职场', slug: 'urban', count: 1892, icon: 'ri-building-line', description: '律师、医生、金融精英……都市职场类韩漫带你走进各行各业的精彩故事，在钢筋水泥的丛林中品味人性与梦想。' },
  thriller: { name: '悬疑惊悚', slug: 'thriller', count: 1245, icon: 'ri-search-eye-line', description: '烧脑推理、心理悬疑、超自然惊悚——每一页都让你屏住呼吸。悬疑惊悚类韩漫用精妙的叙事将你牢牢钉在屏幕前。' },
  martial: { name: '武侠动作', slug: 'martial', count: 1653, icon: 'ri-boxing-line', description: '江湖恩怨、武林争霸、快意恩仇——武侠动作类韩漫融合东方武侠美学与韩漫独特画风，带来拳拳到肉的视觉冲击。' },
  scifi: { name: '科幻未来', slug: 'scifi', count: 987, icon: 'ri-rocket-line', description: '星际旅行、人工智能、未来世界——科幻类韩漫用大胆的想象力探索科技与人性的边界，每一部都让你大开眼界。' },
  school: { name: '青春校园', slug: 'school', count: 2108, icon: 'ri-book-open-line', description: '社团活动、校园恋爱、高考压力——青春校园类韩漫记录下最真实的学生时代，那些闪闪发光的日常与成长。' },
  food: { name: '美食治愈', slug: 'food', count: 756, icon: 'ri-restaurant-line', description: '美食是最好的治愈良药。美食治愈类韩漫用温暖的画风描绘一道道美食背后的故事，让味蕾与心灵同时得到满足。' },
};

export const categoryStats = {
  totalComics: 12860,
  dailyUpdates: 86,
  activeReaders: 325000,
};

export const aboutPageData = {
  brandStory: '韩漫吧创立于2021年，由一群热爱韩国漫画的资深读者共同打造。我们深知韩漫爱好者在寻找高质量中文资源时的困难——散落各处的更新、良莠不齐的翻译、繁杂的广告干扰。于是，我们决定做一件事：打造一个纯粹、免费、高品质的韩漫阅读空间。',
  milestones: [
    { year: '2021', title: '平台创立', description: '三位韩漫爱好者联合创立韩漫吧，首批上线500部热门韩漫' },
    { year: '2022', title: '读者破10万', description: '月活用户突破10万，上架漫画超过3000部，完成第一轮翻译团队扩充' },
    { year: '2023', title: '功能升级', description: '推出下拉式阅读器、智能推荐系统、社区评论区，阅读体验全面升级' },
    { year: '2024', title: '生态完善', description: '漫画资源突破10000部，日均更新超80部，成为华语圈最大韩漫平台之一' },
    { year: '2025', title: '持续成长', description: '注册读者超32.5万，与多家韩国漫画工作室达成合作，持续引进优质正版内容' },
  ],
  advantages: [
    { title: '完全免费', description: '所有漫画免费阅读，无隐藏收费，无人为限制。我们相信好内容应该被每个人自由享受。', icon: 'ri-money-cny-circle-line' },
    { title: '极速更新', description: '专业翻译团队24小时轮班，热门连载做到与韩国同步更新，让你永远走在追更第一线。', icon: 'ri-flashlight-line' },
    { title: '流畅阅读', description: '自研下拉式阅读器，告别翻页等待。自适应屏幕尺寸，手机和电脑都有绝佳体验。', icon: 'ri-smartphone-line' },
    { title: '精选推荐', description: '编辑团队每天精选优质作品，智能算法根据你的阅读口味精准推荐，发现心头好不再难。', icon: 'ri-star-line' },
    { title: '社区互动', description: '每部漫画都有专属评论区，和全国漫画同好一起讨论剧情、分享感受，阅读不再孤单。', icon: 'ri-group-line' },
    { title: '安全可靠', description: '采用先进的内容审核机制，确保所有漫画内容健康合规。保护未成年人，营造绿色阅读环境。', icon: 'ri-shield-check-line' },
  ],
  faqs: [
    { question: '韩漫吧上的漫画都是免费的吗？', answer: '是的，韩漫吧上的所有漫画均完全免费阅读。我们通过社区支持和合作伙伴赞助维持运营，不向读者收取任何费用。' },
    { question: '韩漫吧的漫画资源从哪里来？', answer: '我们的漫画资源来自官方授权合作、翻译团队汉化以及社区贡献。所有内容均经过审核确保质量和版权合规。' },
    { question: '如何加入韩漫吧的翻译团队？', answer: '我们长期招募韩语翻译志愿者。如果你精通韩语、热爱漫画，欢迎通过商务合作表单联系我们，备注"翻译志愿者申请"。' },
    { question: '为什么有些漫画章节加载较慢？', answer: '加载速度与你的网络环境和服务器负载有关。我们建议在网络良好的环境下使用Wi-Fi阅读，同时我们也在持续优化服务器性能。' },
    { question: '支持离线阅读吗？', answer: '目前暂不支持离线下载功能，但我们正在开发中。你可以通过手机浏览器的"添加到主屏幕"功能获得更接近APP的阅读体验。' },
  ],
};